import { jsx as _jsx } from "react/jsx-runtime";
export function Skeleton({ className = '' }) {
    return (_jsx("div", { role: "status", "aria-busy": "true", "aria-label": "Loading", className: `animate-pulse rounded-md bg-slate-200/80 ${className}` }));
}
export function SkeletonText({ lines = 3 }) {
    return (_jsx("div", { className: "space-y-2", children: Array.from({ length: lines }).map((_, i) => (_jsx(Skeleton, { className: `h-3 ${i === lines - 1 ? 'w-4/6' : 'w-full'}` }, i))) }));
}
// push2 polish: re-export the premium shimmer variants from the same module
// so callers can choose. Existing Skeleton/SkeletonText API is untouched.
export { SkeletonShimmer, SkeletonShimmerText } from './SkeletonShimmer';
